"use client";
import { useEffect, useState } from "react";
import { BACKEND_URL, makeRequestAuth, uploadFiles } from "../../_config/api";
import { showErrorToast, showSuccessToast } from "../../utils/toastUtils";
import { ToastContainer } from "react-toastify";
import axios from "axios";
import { FiCalendar, FiMapPin, FiMessageSquare } from "react-icons/fi";
import { FaCog, FaPlus, FaUser } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const timeSlotsList = [
    "7:30 to 9:30 AM",
    "9:30 to 11:30 AM",
    "11:30am to 1:30 pm",
    "2:00 pm to 4:00 pm",
    "4:00 pm to 6:00 pm",
    "6:00 pm to 8:00 PM"
];

export default function BookingRequest() {
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const navigate = useNavigate()
    const [data, setData] = useState([]);
    const [serviceAgents, setServiceAgents] = useState([]);
    const [serviceList, setServiceList] = useState([]);
    const [selectedDate, setSelectedDate] = useState(""); 
    const [bookingSource, setBookingSource] = useState("");
    const [loading, setLoading] = useState(true);

    const [pageNo, setPageNo] = useState(1);
    const [serviceId, setServiceId] = useState("");
    const pageSize = 10;
    const [totalPages, setTotalPages] = useState(1);

    const [search, setSearch] = useState("");
    const [status, setStatus] = useState("");
    const [updatingId, setUpdatingId] = useState(null);

    const [modalType, setModalType] = useState(null);
    // "assign" | "reject" | null

    const [selectedBooking, setSelectedBooking] = useState(null);

    const [assignService, setAssignService] = useState("");
    const [serviceAjentImage, setServiceAjentImage] = useState("");
    const [serviceAjentImageLoading, setServiceAjentImageLoading] = useState(false);
    const [rejectReason, setRejectReason] = useState("");

    const [viewModal, setViewModal] = useState(false);
    const [viewData, setViewData] = useState(null);
    const [previewImage, setPreviewImage] = useState(null);

    const [createModal, setCreateModal] = useState(false);
    const [excelModalOpen, setExcelModalOpen] = useState(false);

    const [customServiceName, setCustomServiceName] = useState("");


    const [newBooking, setNewBooking] = useState({
        name: "",
        phone: "",
        email: "",
        serviceId: "",
        address: "",
        message: "",
        paymentMode: "cash",
        items: [],
        serviceFee: 0,
        serviceDate: "",
        serviceTimeSlot: ""    
    });



    const [extraServiceModal, setExtraServiceModal] = useState(false);
    const [selectedBookingForExtra, setSelectedBookingForExtra] = useState(null);
    const [selectedServiceId, setSelectedServiceId] = useState("");
    const [extraPrice, setExtraPrice] = useState("");



    /* ================= FETCH LIST ================= */
    const fetchBookings = async () => {
        try {
            setLoading(true);
            const res = await makeRequestAuth(
                "post",
                "/admin/getUserServiceList",
                {
                    pageNo,
                    size: pageSize,
                    keyword: search,
                    status,
                    serviceType: serviceId,
                    serviceDate: selectedDate,
                    bookingSource: bookingSource 
                }
            );

            if (res?.error) {
                setData([]);
                return;
            }

            setData(res?.data?.list || []);
            setTotalPages(Math.ceil((res?.data?.total || 0) / pageSize));
        } catch (err) {
            setData([]);
        } finally {
            setLoading(false);
        }
    };

    const fetchServices = async () => {
        try {
            const res = await makeRequestAuth(
                "post",
                "/admin/getListServiceCategory",
                {}
            );

            if (!res?.error) {
                setServiceList(res.data?.list || []);
            }
        } catch (err) {
            setServiceList([]);
        }
    };

    async function fetchAgents(serviceId) {
        try {
            const res = await makeRequestAuth(
                "post",
                "/admin/getSerciveJobsList", {
                serviceId,
                status: "approved",
            }
            );
            if (res?.error) {
                showErrorToast("Failed to load service agents");
                setServiceAgents([]);
            }
            setServiceAgents(res?.data?.list || []);
        } catch (err) {
            setServiceAgents([]);
        }
    };

    useEffect(() => {
        fetchServices();
    }, []);

    useEffect(() => {
        const timer = setTimeout(fetchBookings, 200);
        return () => clearTimeout(timer);
    }, [search, status, pageNo, serviceId, selectedDate, bookingSource]);

    const updateStatus = async (id, status, payload = {}) => {
        try {
            setUpdatingId(id);

            const res = await makeRequestAuth(
                "post",
                "/admin/updateUserServiceStatus",
                {
                    id,
                    status,
                    ...payload
                }
            );

            if (res?.error) {
                return showErrorToast(res.message || "Status update failed");
            }

            showSuccessToast("Status updated");
            fetchBookings();
            setServiceAjentImage("");

        } catch (err) {
            showErrorToast(err.message || "Server error");
        } finally {
            setUpdatingId(null);
        }
    };

    const handleStatusChange = (item, newStatus) => {
        setSelectedBooking(item);
        if (newStatus === "assigned") {
            setModalType("assign");
            fetchAgents(item?.serviceType?._id);
        }
        else if (newStatus === "rejected") {
            setModalType("reject");
        }
        else if (newStatus === "complete") {
            setModalType("confirm_complete");
        }
        else {
            updateStatus(item._id, newStatus);
        }
    };


    // Lines 183 se 201 tak replace karein:
    // Current booking ki Service Category find karein
    const currentCategory = serviceList.find(
        (s) => s._id === (selectedBookingForExtra?.serviceType?._id || selectedBookingForExtra?.serviceType)
    );

    // Us service ke sub-services (pricingOptions)
    const availableSubServices = currentCategory?.pricingOptions || [];

    const openExtraServiceModal = (item) => {
        setSelectedBookingForExtra(item);
        setSelectedServiceId("");
        setCustomServiceName("");
        setExtraPrice("");
        setExtraServiceModal(true);
    };

    // Jab user dropdown me sub-service select kare, toh Price auto-fill ho jaye
    const handleSubServiceChange = (title) => {
        setSelectedServiceId(title);
        const selectedOption = availableSubServices.find((opt) => opt.title === title);
        if (selectedOption) {
            setExtraPrice(selectedOption.price);
        }
    };

    const handleSaveExtraService = async () => {
        // Agar manual custom input mein likha hai toh wo use hoga, nahi toh dropdown ki value
        const finalTitle = customServiceName.trim() || selectedServiceId;

        if (!finalTitle || !extraPrice) {
            return showErrorToast("Please select or enter a service name and price");
        }

        const updatedItems = [
            ...(selectedBookingForExtra.items || []),
            {
                title: finalTitle,
                price: Number(extraPrice),
                isExtra: true
            }
        ];

        const validStatuses = ["pending", "assigned", "in_progress", "on_the_way", "complete", "rejected"];
        let currentStatus = selectedBookingForExtra?.status;

        if (!validStatuses.includes(currentStatus)) {
            currentStatus = selectedBookingForExtra?.serviceBoy ? "assigned" : "pending";
        }

        const payload = {
            items: updatedItems
        };

        if (currentStatus === "in_progress") {
            payload.serviceProviderImage =
                selectedBookingForExtra?.serviceProviderImage ||
                selectedBookingForExtra?.serviceBoy?.profileImage ||
                "https://cdn-icons-png.flaticon.com/512/3135/3135715.png";
        }

        await updateStatus(selectedBookingForExtra._id, currentStatus, payload);
        setExtraServiceModal(false);
        fetchBookings();
    };


    const handlePhoneBlur = async (e) => {
        const phone = e.target.value;
        setNewBooking({ ...newBooking, phone });

        if (phone.length >= 10) {
            try {
                const res = await makeRequestAuth("post", '/admin/searchUserByPhone', { phone });
                if (res && res.data && res.data.length > 0) {
                    const user = res.data[0];
                    setNewBooking(prev => ({
                        ...prev,
                        name: user.name || "",
                        email: user.email || ""
                    }));
                }
            } catch (err) {
                console.log("User not found, will create new");
            }
        }
    };

    const handleCreateBooking = async () => {
        if (!newBooking.phone || !newBooking.serviceId) {
            return showErrorToast("Phone and Service are required!");
        }
        try {
            const res = await makeRequestAuth("post", '/admin/createManualBooking', newBooking);
            if (res?.error) {
                showErrorToast(res.message || "Failed to create booking");
            } else {
                showSuccessToast("Booking created successfully!");
                setCreateModal(false);
                // Nayi Line:
                setNewBooking({ name: "", phone: "", email: "", serviceId: "", address: "", message: "", paymentMode: "cash", items: [], serviceFee: 0, serviceDate: "", serviceTimeSlot: "" });
                fetchBookings();
            }
        } catch (err) {
            showErrorToast(err.message || "Server Error");
        }
    };






    const closeModal = () => {
        setModalType(null);
        setSelectedBooking(null);
        setAssignService("");
        setRejectReason("");
        setServiceAjentImage("")
    };


    const handleExcelDownload = async () => {
        setExcelModalOpen(false);
        const { token } = JSON.parse(sessionStorage.getItem("user")) || {}
        if (!token) return
        try {
            const res = await axios.post(
                BACKEND_URL + "/admin/exportServicBokkingeExcel",
                {
                    keyword: search,
                    status,
                    serviceType: serviceId,
                    startDate,
                    endDate,
                },
                {
                    responseType: "blob",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            const fileBlob =
                res instanceof Blob
                    ? res
                    : res?.data instanceof Blob
                        ? res.data
                        : new Blob([res], {
                            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        });


            const url = window.URL.createObjectURL(fileBlob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `booking_requests_${Date.now()}.xlsx`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);

        } catch (err) {
            showErrorToast("Excel download failed");
        }
    };


    const prevPage = () => pageNo > 1 && setPageNo((p) => p - 1);
    const nextPage = () => pageNo < totalPages && setPageNo((p) => p + 1);

    return (
        <div className="p-6 min-h-screen bg-white">
            <ToastContainer />
            {/* ================= HEADER ================= */}
            <div className="flex justify-between items-center mb-6">
                <div>
                    <h2 className="text-3xl font-[900] text-slate-800 tracking-tight">
                        Booking Requests
                    </h2>
                    <p className="text-slate-500 text-sm font-medium mt-1">
                        Manage and monitor your incoming service orders
                    </p>
                </div>

                <div className="flex items-center gap-3 w-full md:w-auto">
                    {/* SERVICE SETTINGS BUTTON */}
                    <button
                        onClick={() => navigate("/services/setting")}
                        className="p-3.5 rounded-2xl bg-white border border-slate-200 text-slate-600 hover:text-[#24ADD7] hover:border-[#24ADD7] hover:shadow-lg hover:shadow-orange-100 transition-all duration-300 group"
                        title="Service Settings"
                    >
                        <FaCog className="text-xl group-hover:rotate-90 transition-transform duration-500" />
                    </button>

                    {/* CREATE BOOKING BUTTON */}
                    <button
                        onClick={() => setCreateModal(true)}
                        className="flex-1 md:flex-none flex items-center justify-center gap-2 px-6 py-3.5 rounded-2xl text-sm font-bold
                bg-slate-900 text-white hover:bg-[#24ADD7] shadow-xl shadow-slate-200 hover:shadow-none active:scale-95 transition-all duration-300"
                    >
                        <FaPlus className="text-xs" />
                        <span>Create Booking</span>
                    </button>
                </div>

            </div>

            {/* ================= FILTER BAR (SAME AS LOAN QUERY) ================= */}
            <div className="bg-white border border-gray-200 rounded-2xl p-4 mb-6 shadow-sm">
                <div className="flex flex-wrap gap-4 items-end">

                    {/* 🔍 SEARCH */}
                    <div className="relative flex-1 min-w-[220px]">
                        <input
                            type="text"
                            placeholder="Search name / phone / email"
                            value={search}
                            onChange={(e) => {
                                setPageNo(1);
                                setSearch(e.target.value);
                            }}
                            className="pl-10 pr-4 py-2 border border-gray-200 rounded-xl w-full
              text-sm text-[#434646] focus:border-[#24ADD7] outline-none"
                        />
                        <svg
                            className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                        </svg>
                    </div>

                    {/* STATUS FILTER */}
                    <select
                        value={status}
                        onChange={async (e) => {
                            const value = e.target.value;
                            setPageNo(1);
                            setStatus(value);
                        }}
                        className="px-4 py-2 rounded-xl border border-gray-200 text-sm
            text-[#434646] focus:border-[#24ADD7] outline-none"
                    >
                        <option value="">All Status</option>
                        <option value="pending">Pending</option>
                        <option value="in_progress">Assigning</option>
                        <option value="complete">Complete</option>
                        <option value="rejected">Rejected</option>
                    </select>

                    {/* 🌐 BOOKING SOURCE FILTER */}
                    <select
                        value={bookingSource}
                        onChange={(e) => {
                            setPageNo(1);
                            setBookingSource(e.target.value);
                        }}
                        className="px-4 py-2 rounded-xl border border-gray-200 text-sm text-[#434646] focus:border-[#24ADD7] outline-none"
                    >
                        <option value="">All Sources</option>
                        <option value="web">🌐 Web (Customer)</option>
                        <option value="manual">👤 Manual (Admin)</option>
                    </select>


                    {/* SERVICE FILTER */}
                    <select
                        value={serviceId}
                        onChange={(e) => {
                            setPageNo(1);
                            setServiceId(e.target.value);
                        }}
                        className="px-4 py-2 rounded-xl border border-gray-200 text-sm
  text-[#434646] focus:border-[#24ADD7] outline-none"
                    >
                        <option value="">All Services</option>

                        {serviceList.map((service) => (
                            <option key={service._id} value={service._id}>
                                {service.name}
                            </option>
                        ))}
                    </select>
                                        {/* 📅 YEH NAYA DATE FILTER ADD KAREIN 👇 */}
                    <input
                        type="date"
                        value={selectedDate}
                        onChange={(e) => {
                            setPageNo(1);
                            setSelectedDate(e.target.value);
                        }}
                        className="px-4 py-2 rounded-xl border border-gray-200 text-sm text-[#434646] focus:border-[#24ADD7] outline-none cursor-pointer"
                    />
                    <button
                        onClick={() => setExcelModalOpen(true)}
                        className="px-5 py-2 rounded-xl text-sm font-semibold
  bg-[#24ADD7] text-white hover:bg-[#065870] transition"
                    >
                        ⬇ Download Excel
                    </button>

                    {/* CLEAR */}
                    {(search || status || serviceId) && (
                        <button
                            onClick={() => {
                                setSearch("");
                                setStatus("");
                                setServiceId('');
                                setSelectedDate("");
                                setBookingSource("");
                                setPageNo(1);
                            }}
                            className="px-4 py-2 rounded-xl text-sm font-semibold
              border border-[#24ADD7] text-[#24ADD7]
              hover:bg-[#24ADD7] hover:text-white transition"
                        >
                            Clear All
                        </button>
                    )}
                </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 p-6">
                {/* Empty State */}
                {!loading && data.length === 0 && (
                    <div className="col-span-full text-center py-40 bg-white rounded-[40px] border-2 border-dashed border-gray-100">
                        <p className="text-gray-400 font-bold text-lg tracking-tight">No booking requests found</p>
                    </div>
                )}

                {data.map((item, key) => (
                    <div
                        key={item._id}
                        className="bg-white rounded-[32px] border border-gray-100 shadow-sm hover:shadow-xl transition-all duration-300 flex flex-col overflow-hidden group"
                    >
                        {/* 1. Header: Dark Theme with Status */}
                        <div className="px-6 py-5 bg-gray-900 flex justify-between items-center">
                            <div className="flex flex-col">
                                <div className="flex items-center gap-2">
                                    <span className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em]">Booking Reference</span>
                                    {/* 🏷️ SOURCE BADGE */}
                                    {item.bookingSource === "manual" || item.name ? (
                                        <span className="text-[9px] font-black bg-amber-500/20 text-amber-300 border border-amber-500/30 px-2 py-0.5 rounded-md uppercase">
                                            Admin Manual
                                        </span>
                                    ) : (
                                        <span className="text-[9px] font-black bg-emerald-500/20 text-emerald-300 border border-emerald-500/30 px-2 py-0.5 rounded-md uppercase">
                                            Web Customer
                                        </span>
                                    )}
                                </div>
                                <span className="text-base font-bold text-white tracking-tight">{item.bookingId || "SRV-N/A"}</span>
                            </div>

                            <div className="flex items-center gap-3">
                                {/* 1. Add Extra Service Button */}
                                <button
                                    type="button"
                                    onClick={() => openExtraServiceModal(item)}
                                    className="px-3 py-2 rounded-xl whitespace-nowrap  text-[11px] font-black bg-[#24ADD7] text-white hover:bg-[#198cae] transition-colors shadow-md"
                                >
                                    + Add Extra Service
                                </button>

                                {/* 2. Status / Assign Agent Dropdown */}
                                {/* 2. Status / Assign Agent Dropdown */}
                                <select
                                    value={item.status || "pending"}
                                    disabled={
                                        updatingId === item._id ||
                                        item.status === "complete" ||
                                        item.status === "rejected"
                                    }
                                    onChange={(e) => handleStatusChange(item, e.target.value)}
                                    className={`px-4 py-2 rounded-xl w-[137px] text-[11px] font-black border-none outline-none cursor-pointer transition-colors
        ${item.status === "complete"
                                            ? "bg-green-500 text-white"
                                            : item.status === "rejected"
                                                ? "bg-red-500 text-white"
                                                : (item.status === "waiting_for_payment" || item.status === "waiting_for_approval")
                                                    ? "bg-orange-500 text-white"
                                                    : item.status === "assigned"
                                                        ? "bg-blue-500 text-white"
                                                        : item.status === "in_progress"
                                                            ? "bg-blue-500 text-white"
                                                            : "bg-[#24ADD7] text-white"
                                        }
    `}
                                >
                                    <option value="pending">PENDING</option>
                                    <option value="assigned">ASSIGN AGENT</option>
                                    {item.status === "in_progress" && (
                                        <option value="in_progress">IN PROGRESS / WORKING</option>
                                    )}
                                    {item.status === "on_the_way" && (
                                        <option value="on_the_way">ON THE WAY</option>
                                    )}

                                    {/* 👇 YAHAN BADLAAV HUA HAI: waiting_for_payment par bhi DONE BY AGENT dikhega 👇 */}
                                    {(item.status === "waiting_for_payment" || item.status === "waiting_for_approval") && (
                                        <option value={item.status}>DONE BY AGENT</option>
                                    )}

                                    <option value="complete">COMPLETE</option>
                                    <option value="rejected">REJECTED</option>
                                    <option value="waiting_for_user_review">Waiting For User Review</option>
                                </select>

                            </div>
                        </div>

                        <div className="p-8 space-y-8">
                            {/* 2. Service Info & Schedule Section */}
                            <div className="flex flex-col sm:flex-row justify-between gap-6 border-b border-gray-50 pb-6">
                                <div className="flex items-center gap-5">
                                    <div className="w-16 h-16 rounded-[20px] overflow-hidden bg-gray-50 border border-gray-100 p-1 flex-shrink-0">
                                        <img src={item.serviceType?.image} className="w-full h-full object-cover rounded-[14px]" alt="service" />
                                    </div>
                                    <div>
                                        <h4 className="text-xl font-black text-gray-900 leading-none uppercase italic">{item.serviceType?.name}</h4>
                                        <div className="flex items-center gap-2 mt-2">
                                            <span className="text-[#24ADD7] text-lg font-black">
                                                ₹{
                                                    (!item.items || item.items.length === 0)
                                                        ? (item.serviceFee || 0)
                                                        : item.items.some(i => !i.isExtra)
                                                            ? (item.items.reduce((sum, i) => sum + (Number(i.price) || 0), 0) + Number(item.serviceType?.serviceFee ?? item.serviceCharge ?? 0))
                                                            : ((Number(item.serviceFee) || 0) + item.items.reduce((sum, i) => sum + (Number(i.price) || 0), 0))
                                                }
                                            </span>
                                            <span className="text-[10px] bg-gray-100 text-gray-500 px-2 py-0.5 rounded-md font-bold uppercase tracking-wider">{item.paymentStatus} {item.paymentMethod ? `(${item.paymentMethod})` : '(Online)'}
                                           </span>
                                        </div>

                                        {item.items && item.items.length > 0 && (
                                            <div className="flex flex-wrap gap-1.5 mt-2">
                                                {item.items.map((sub, idx) => (
                                                    <span key={idx} className="text-[10px] font-bold bg-blue-50 text-blue-700 px-2 py-0.5 rounded-md border border-blue-100">
                                                        {sub.title} (₹{sub.price})
                                                    </span>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className="bg-gray-50 px-5 py-3 rounded-2xl border border-gray-100 flex flex-col justify-center min-w-[140px]">
                                    <div className="flex items-center gap-2 text-gray-400 mb-1">
                                        <FiCalendar size={14} />
                                        <span className="text-[9px] font-black uppercase tracking-widest text-gray-400">Schedule</span>
                                    </div>
                                    <p className="text-xs font-black text-gray-900 uppercase">
                                        {new Date(item.serviceDate).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}
                                    </p>
                                    <p className="text-[10px] font-bold text-gray-500">{item.serviceTimeSlot}</p>
                                </div>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                                {/* Customer Side */}
                                <div className="space-y-4">
                                    <p className="text-[10px] font-black text-gray-400 uppercase tracking-[0.15em] flex items-center gap-2">
                                        <span className="w-2 h-2 bg-[#24ADD7] rounded-full"></span> Customer
                                    </p>
                                    <div className="flex items-center gap-4">
                                        {item.userId?.image ? (
                                            <img
                                                src={item.userId.image}
                                                className="w-12 h-12 rounded-full border-2 border-white shadow-md flex-shrink-0 object-cover"
                                                alt="user"
                                            />
                                        ) : (
                                            <div className="w-12 h-12 rounded-full bg-gray-100 border-2 border-white shadow-md flex-shrink-0 flex items-center justify-center text-gray-400">
                                                <FaUser size={20} />
                                            </div>
                                        )}


                                        <div className="min-w-0">
                                            <p className="text-[14px] font-black text-gray-900 truncate uppercase tracking-tight">{item.userId?.name || item.name}</p>
                                            <p className="text-[11px] font-bold text-gray-500">{item.userId?.phone || item.phone}</p>

                                        </div>
                                    </div>
                                    <div className="flex items-start gap-2 bg-gray-50/50 p-3 rounded-xl">
                                        <FiMapPin className="text-[#24ADD7] mt-0.5" size={14} />
                                        <p className="text-[11px] text-gray-600 font-medium leading-relaxed italic">{item.address}</p>
                                    </div>
                                </div>

                                {/* Agent Side */}
                                <div className="space-y-4">
                                    <p className="text-[10px] font-black text-gray-400 uppercase tracking-[0.15em] flex items-center gap-2">
                                        <span className="w-2 h-2 bg-blue-500 rounded-full"></span> Service Agent
                                    </p>
                                    {item.serviceBoy ? (
                                        <div className="flex items-center gap-4">
                                            <img src={item.serviceProviderImage || item.serviceBoy?.image || item.serviceBoy?.profilePicture || item.serviceBoy?.profileImage} className="w-12 h-12 rounded-full border-2 border-white shadow-md flex-shrink-0" alt="agent" />
                                            <div className="min-w-0">
                                                <p className="text-[14px] font-black text-blue-900 truncate uppercase tracking-tight">{item.serviceBoy.name}</p>
                                                <p className="text-[11px] font-bold text-blue-600">{item.serviceBoy.phone}</p>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="h-12 flex items-center justify-center bg-gray-50 rounded-2xl border border-dashed border-gray-200">
                                            <p className="text-[10px] font-bold text-gray-400 uppercase italic">Awaiting Assignment</p>
                                        </div>
                                    )}
                                    <div className="h-[52px]"> {/* Spacer to match height */} </div>
                                </div>
                            </div>

                            {/* 4. Action Area */}
                            <div className="pt-6 border-t border-gray-50 flex items-center justify-between">
                                <div className="flex items-center gap-4">
                                    {item.problemImgae && (
                                        <div className="flex flex-col items-center gap-1">
                                            <img src={item.problemImgae} className="w-12 h-12 rounded-xl object-cover border-2 border-white shadow-lg hover:scale-105 transition-transform cursor-zoom-in" alt="problem" />
                                            <span className="text-[8px] font-black text-gray-400 uppercase tracking-widest">Issue Log</span>
                                        </div>
                                    )}
                                </div>

                                <button
                                    onClick={() => { setViewData(item); setViewModal(true); }}
                                    className="bg-gray-900 text-white text-[11px] font-black px-8 py-4 rounded-2xl hover:bg-[#24ADD7] transition-all uppercase tracking-widest shadow-xl shadow-gray-200/50 active:scale-95"
                                >
                                    Detailed Review
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* ================= PAGINATION ================= */}
            {totalPages > 1 && (
                <div className="flex justify-center items-center gap-4 mt-6 p-3 bg-white rounded-2xl shadow-lg border">
                    <button
                        onClick={prevPage}
                        disabled={pageNo === 1}
                        className="px-4 py-2 border-2 border-[#24ADD7] rounded-xl
            text-[#24ADD7] disabled:opacity-50 hover:bg-[#24ADD7] hover:text-white"
                    >
                        ← Prev
                    </button>

                    <span className="font-semibold text-[#434646]">
                        Page {pageNo} of {totalPages}
                    </span>

                    <button
                        onClick={nextPage}
                        disabled={pageNo === totalPages}
                        className="px-4 py-2 border-2 border-[#24ADD7] rounded-xl
            text-[#24ADD7] disabled:opacity-50 hover:bg-[#24ADD7] hover:text-white"
                    >
                        Next →
                    </button>
                </div>
            )}

            {/* View Service Modal */}
            {viewModal && viewData && (
                <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-[32px] w-full max-w-[550px] overflow-hidden shadow-2xl border border-gray-100 flex flex-col max-h-[90vh]">
                        {previewImage && (
                            <div
                                className="fixed inset-0 bg-black/90 z-[60] flex items-center justify-center p-4 cursor-zoom-out"
                                onClick={() => setPreviewImage(null)}
                            >
                                <div className="relative max-w-4xl max-h-full">
                                    <img
                                        src={previewImage}
                                        className="rounded-lg shadow-2xl max-h-[85vh] object-contain border-4 border-white/10"
                                        alt="Preview"
                                    />
                                    <button className="absolute -top-10 right-0 text-white text-3xl font-light">×</button>
                                </div>
                            </div>
                        )}

                        {/* 1. Header: Dark & Bold */}
                        <div className="bg-gray-900 px-8 py-6 flex justify-between items-center">
                            <div className="flex flex-col">
                                <span className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] mb-1">Detailed View</span>
                                <h3 className="text-xl font-black text-white tracking-tight uppercase italic">
                                    {viewData.bookingId || "Booking Details"}
                                </h3>
                            </div>
                            <button
                                onClick={() => setViewModal(false)}
                                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-[#24ADD7] transition-all text-2xl font-light"
                            >
                                ×
                            </button>
                        </div>

                        <div className="p-8 overflow-y-auto space-y-8">

                            {/* 2. Section: Customer Profile */}
                            <div className="space-y-4">
                                <p className="text-[11px] font-black text-gray-400 uppercase tracking-widest flex items-center gap-3">
                                    <span className="w-6 h-[1px] bg-gray-200"></span> Customer Info
                                </p>
                                <div className="flex items-center gap-5 bg-gray-50 p-4 rounded-2xl border border-gray-100">
                                    {(viewData.userId?.image || viewData.image) ? (
                                        <img
                                            src={viewData.userId?.image || viewData.image}
                                            onClick={() => setPreviewImage(viewData.userId?.image || viewData.image)}
                                            className="w-14 h-14 rounded-full border-4 border-white shadow-sm object-cover cursor-pointer"
                                            alt="User"
                                        />
                                    ) : (
                                        <div className="w-14 h-14 rounded-full bg-gray-100 border-4 border-white shadow-sm flex items-center justify-center text-gray-400 font-bold">
                                            <FaUser size={24} />
                                        </div>
                                    )}


                                    <div className="space-y-0.5">
                                        <h4 className="text-base font-black text-gray-900 uppercase tracking-tight">{viewData.userId?.name || viewData.name || "N/A"}</h4>
                                        <p className="text-sm font-bold text-gray-500">{viewData.userId?.phone || viewData.phone || "N/A"}</p>
                                        {(viewData.userId?.email || viewData.email) && (
                                            <p className="text-xs font-medium text-gray-400">{viewData.userId?.email || viewData.email}</p>
                                        )}


                                    </div>
                                </div>
                            </div>

                            {/* 3. Section: Service & Requirements */}
                            <div className="space-y-4">
                                <p className="text-[11px] font-black text-gray-400 uppercase tracking-widest flex items-center gap-3">
                                    <span className="w-6 h-[1px] bg-gray-200"></span> Service & Address
                                </p>
                                <div className="grid grid-cols-1 gap-4 bg-orange-50/30 p-5 rounded-2xl border border-orange-100/50">
                                    <div className="flex items-center gap-3">
                                        <div className="w-10 h-10 rounded-lg bg-white border border-orange-100 flex items-center justify-center flex-shrink-0">
                                            <img src={viewData.serviceType?.image} onClick={() => setPreviewImage(viewData.serviceType?.image)} className="w-8 h-8 object-contain" />
                                        </div>
                                        <span className="text-base font-black text-gray-800 uppercase italic">{viewData.serviceType?.name}</span>
                                    </div>

                                    <div className="space-y-3 pt-2">
                                        <div className="flex items-start gap-2">
                                            <FiMapPin className="text-[#24ADD7] mt-1 flex-shrink-0" size={16} />
                                            <p className="text-sm font-bold text-gray-700 leading-relaxed italic">{viewData.address || "N/A"}</p>
                                        </div>
                                        <div className="flex items-start gap-2 bg-white/60 p-3 rounded-xl border border-white">
                                            <FiMessageSquare className="text-gray-400 mt-1 flex-shrink-0" size={16} />
                                            <p className="text-sm text-gray-500 font-medium italic">"{viewData.message || "No specific instructions provided"}"</p>
                                        </div>
                                    </div>

                                    <div className="bg-gray-50 px-5 py-3 rounded-2xl border border-gray-100 flex flex-col justify-center min-w-[140px]">
                                        <div className="flex items-center gap-2 text-gray-400 mb-1">
                                            <FiCalendar size={14} />
                                            <span className="text-[9px] font-black uppercase tracking-widest text-gray-400">Schedule</span>
                                        </div>
                                        <p className="text-xs font-black text-gray-900 uppercase">
                                            {new Date(viewData.serviceDate).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}
                                        </p>
                                        <p className="text-[10px] font-bold text-gray-500">{viewData.serviceTimeSlot}</p>
                                    </div>
                                </div>
                                {/* 📦 Sub-Services / Selected Packages (Cart Items) */}
                                {viewData.items && viewData.items.length > 0 && (
                                    <div className="space-y-3 pt-2">
                                        <p className="text-[11px] font-black text-gray-400 uppercase tracking-widest flex items-center gap-3">
                                            <span className="w-6 h-[1px] bg-gray-200"></span> Selected Sub-Services / Packages
                                        </p>
                                        <div className="space-y-2">
                                            {viewData.items.map((subItem, idx) => (
                                                <div
                                                    key={idx}
                                                    className="flex items-center justify-between bg-gray-50 p-3.5 rounded-2xl border border-gray-100 shadow-sm"
                                                >
                                                    <div className="flex items-center gap-3">
                                                        {subItem.image ? (
                                                            <img
                                                                src={subItem.image}
                                                                alt={subItem.title}
                                                                onClick={() => setPreviewImage(subItem.image)}
                                                                className="w-10 h-10 rounded-xl object-cover border border-gray-200 cursor-pointer"
                                                            />
                                                        ) : (
                                                            <div className="w-10 h-10 rounded-xl bg-blue-100 text-[#24ADD7] flex items-center justify-center font-black text-sm uppercase">
                                                                {subItem.title ? subItem.title.charAt(0) : "S"}
                                                            </div>
                                                        )}
                                                        <div>
                                                            <div className="flex items-center gap-2">
                                                                <h5 className="text-sm font-black text-gray-800">{subItem.title}</h5>
                                                                {subItem.isExtra && (
                                                                    <span className="text-[9px] font-black bg-purple-100 text-purple-700 px-2 py-0.5 rounded-md border border-purple-200 uppercase tracking-wider">
                                                                        Extra Added
                                                                    </span>
                                                                )}
                                                            </div>
                                                            {subItem.description && (
                                                                <p className="text-xs text-gray-500 mt-0.5">{subItem.description}</p>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <span className="text-sm font-black text-[#24ADD7] bg-white px-3 py-1.5 rounded-xl border border-gray-200 shadow-sm">
                                                        ₹{subItem.price}
                                                    </span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}

                                <div className="space-y-4">
                                    <p className="text-[11px] font-black text-gray-400 uppercase tracking-widest flex items-center gap-3">
                                        <span className="w-6 h-[1px] bg-gray-200"></span> Problem / Issue Image
                                    </p>

                                    {viewData.problemImgae ? (
                                        <div className="bg-gray-50 p-4 rounded-2xl border border-gray-100">
                                            <div className="relative w-full h-[180px] overflow-hidden rounded-xl border-4 border-white shadow-sm group">
                                                <img
                                                    src={viewData.problemImgae}
                                                    onClick={() => setPreviewImage(viewData.problemImgae)}
                                                    className="w-full h-full object-cover cursor-zoom-in group-hover:scale-105 transition-transform duration-300"
                                                    alt="Problem reported by user"
                                                />
                                                <div className="absolute inset-0 bg-black/10 group-hover:bg-black/0 transition-colors pointer-events-none" />
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="bg-gray-50 p-5 rounded-2xl border border-gray-100 flex items-center justify-center">
                                            <p className="text-xs font-bold text-gray-400 uppercase tracking-wider italic">
                                                No problem image uploaded
                                            </p>
                                        </div>
                                    )}
                                </div>
                            </div>


                            {/* 📸 AGENT WORK PROOF PHOTOS (BEFORE & AFTER) */}
                            <div className="space-y-4 pt-4 border-t border-gray-100">
                                <p className="text-[11px] font-black text-gray-400 uppercase tracking-widest flex items-center gap-3">
                                    <span className="w-6 h-[1px] bg-gray-200"></span> Agent Work Proof Photos
                                </p>

                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">

                                    {/* 1. Before Work Photo (OTP Verify hone ke baad upload hone wali photo) */}
                                    <div className="bg-gray-50 p-3 rounded-2xl border border-gray-100 space-y-2">
                                        <span className="text-[10px] font-black text-blue-600 uppercase tracking-wider block">
                                            📷 1. Before Work Photo (Initial State)
                                        </span>
                                        {viewData.beforeImage ? (
                                            <div className="relative w-full h-[140px] overflow-hidden rounded-xl border-2 border-white shadow-sm group">
                                                <img
                                                    src={viewData.beforeImage}
                                                    onClick={() => setPreviewImage(viewData.beforeImage)}
                                                    className="w-full h-full object-cover cursor-zoom-in group-hover:scale-105 transition-transform duration-300"
                                                    alt="Before Work Photo"
                                                />
                                            </div>
                                        ) : (
                                            <div className="h-[140px] bg-white rounded-xl border border-dashed border-gray-200 flex items-center justify-center p-4 text-center">
                                                <p className="text-[10px] font-bold text-gray-400 uppercase italic">
                                                    Before Photo Not Uploaded Yet
                                                </p>
                                            </div>
                                        )}
                                    </div>

                                    {/* 2. After Work Photo (Work Complete hone par upload hone wali photo) */}
                                    <div className="bg-gray-50 p-3 rounded-2xl border border-gray-100 space-y-2">
                                        <span className="text-[10px] font-black text-green-600 uppercase tracking-wider block">
                                            📷 2. After Work Photo (Final State)
                                        </span>
                                        {viewData.afterImage ? (
                                            <div className="relative w-full h-[140px] overflow-hidden rounded-xl border-2 border-white shadow-sm group">
                                                <img
                                                    src={viewData.afterImage}
                                                    onClick={() => setPreviewImage(viewData.afterImage)}
                                                    className="w-full h-full object-cover cursor-zoom-in group-hover:scale-105 transition-transform duration-300"
                                                    alt="After Work Photo"
                                                />
                                            </div>
                                        ) : (
                                            <div className="h-[140px] bg-white rounded-xl border border-dashed border-gray-200 flex items-center justify-center p-4 text-center">
                                                <p className="text-[10px] font-bold text-gray-400 uppercase italic">
                                                    After Photo Not Uploaded Yet
                                                </p>
                                            </div>
                                        )}
                                    </div>

                                </div>
                            </div>


                            {/* 4. Section: Conditional Status Info */}
                            {(viewData.status === "in_progress" || viewData.serviceBoy) && (
                                <div className="space-y-4">
                                    <p className="text-[11px] font-black text-gray-400 uppercase tracking-widest flex items-center gap-3">
                                        <span className="w-6 h-[1px] bg-blue-200"></span> Service Assignment
                                    </p>
                                    <div className="bg-blue-50/50 p-5 rounded-2xl border border-blue-100 flex items-center gap-4">
                                        {(viewData.serviceProviderImage || viewData.serviceBoy?.image || viewData.serviceBoy?.profilePicture || viewData.serviceBoy?.profileImage) ? (
                                            <img
                                                src={viewData.serviceProviderImage || viewData.serviceBoy?.image || viewData.serviceBoy?.profilePicture || viewData.serviceBoy?.profileImage}
                                                onClick={() => setPreviewImage(viewData.serviceProviderImage || viewData.serviceBoy?.image || viewData.serviceBoy?.profilePicture || viewData.serviceBoy?.profileImage)}
                                                className="w-12 h-12 rounded-full border-2 border-white shadow-sm object-cover cursor-pointer"
                                                alt="Agent"
                                            />
                                        ) : (
                                            <div className="w-12 h-12 rounded-full bg-blue-100 border-2 border-white shadow-sm flex items-center justify-center text-blue-500 font-bold">
                                                <FaUser size={20} />
                                            </div>
                                        )}
                                        <div className="flex-1">
                                            <p className="text-sm font-black text-blue-900 uppercase">{viewData.serviceBoy?.name || "N/A"}</p>
                                            <p className="text-xs font-bold text-blue-600 mb-2">{viewData.serviceBoy?.phone || "N/A"}</p>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {viewData.status === "rejected" && (
                                <div className="p-4 bg-red-50 rounded-2xl border border-red-100">
                                    <p className="text-[11px] font-black text-red-400 uppercase tracking-widest mb-1">Rejection Reason</p>
                                    <p className="text-sm font-bold text-red-700 italic">{viewData.rejectedReason || "Reason not specified"}</p>
                                </div>
                            )}

                        </div>

                        {/* 5. Footer: Clean Action */}
                        <div className="p-6 border-t border-gray-50 bg-gray-50/50 flex justify-end">
                            <button
                                onClick={() => setViewModal(false)}
                                className="px-10 py-3 bg-gray-900 text-white text-[11px] font-black rounded-xl hover:bg-[#24ADD7] transition-all uppercase tracking-[0.2em] shadow-lg shadow-gray-200"
                            >
                                Close Brief
                            </button>
                        </div>

                    </div>
                </div>
            )}

            {/* Create Modal */}
            {createModal && (
                <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-xl w-[450px] p-6 space-y-4 max-h-[90vh] overflow-y-auto">

                        <div className="flex justify-between items-center">
                            <h3 className="text-lg font-semibold text-[#434646]">
                                Create New Booking
                            </h3>
                            <button
                                onClick={() => setCreateModal(false)}
                                className="text-gray-400 text-xl"
                            >
                                ×
                            </button>
                        </div>

                        <input
                            placeholder="User Name"
                            className="w-full border rounded-lg px-3 py-2 text-sm"
                            value={newBooking.name}
                            onChange={(e) =>
                                setNewBooking({ ...newBooking, name: e.target.value })
                            }
                        />
                        <div className="flex gap-2">
                            <input
                                placeholder="Phone"
                                className="w-full border rounded-lg px-3 py-2 text-sm"
                                value={newBooking.phone}
                                onChange={(e) => setNewBooking({ ...newBooking, phone: e.target.value })}
                            />
                            <button 
                                type="button" 
                                onClick={() => handlePhoneBlur({ target: { value: newBooking.phone } })} 
                                className="bg-slate-900 text-white px-4 py-2 rounded-lg text-sm font-semibold hover:bg-[#24ADD7] transition-all whitespace-nowrap"
                            >
                                Search
                            </button>
                        </div>



                        <input
                            placeholder="Email"
                            className="w-full border rounded-lg px-3 py-2 text-sm"
                            value={newBooking.email}
                            onChange={(e) =>
                                setNewBooking({ ...newBooking, email: e.target.value })
                            }
                        />

                        <select
                            className="w-full border rounded-lg px-3 py-2 text-sm"
                            value={newBooking.serviceId}
                            onChange={(e) =>
                                setNewBooking({ ...newBooking, serviceId: e.target.value })
                            }
                        >
                            <option value="">Select Service</option>
                            {serviceList.map((s) => (
                                <option key={s._id} value={s._id}>
                                    {s.name}
                                </option>
                            ))}
                        </select>
                        {/* SERVICE PACKAGES CART */}
                        {(() => {
                            const selectedService = serviceList.find(s => s._id === newBooking.serviceId);
                            if (!selectedService || !selectedService.pricingOptions || selectedService.pricingOptions.length === 0) return null;

                            return (
                                <div className="border rounded-lg p-3 space-y-2 mt-2 max-h-40 overflow-y-auto">
                                    <p className="text-sm font-semibold text-gray-700">Select Packages (Cart):</p>
                                    {selectedService.pricingOptions.map((opt, index) => {
                                        const isSelected = newBooking.items.some(item => item.title === opt.title);
                                        return (
                                            <label key={index} className="flex items-center justify-between text-sm cursor-pointer p-2 hover:bg-gray-50 rounded">
                                                <div className="flex items-center gap-2">
                                                    <input
                                                        type="checkbox"
                                                        className="w-4 h-4 cursor-pointer"
                                                        checked={isSelected}
                                                        onChange={(e) => {
                                                            let newItems = [...newBooking.items];
                                                            if (e.target.checked) {
                                                                newItems.push({ ...opt, qty: 1 });
                                                            } else {
                                                                newItems = newItems.filter(item => item.title !== opt.title);
                                                            }
                                                            const totalFee = newItems.reduce((acc, item) => acc + (item.price * (item.qty || 1)), 0);
                                                            setNewBooking({ ...newBooking, items: newItems, serviceFee: totalFee });
                                                        }}
                                                    />
                                                    <span>{opt.title}</span>
                                                </div>
                                                <span className="font-bold text-[#24ADD7]">₹{opt.price}</span>
                                            </label>
                                        );
                                    })}
                                    <div className="text-right text-[#434646] font-bold pt-2 border-t mt-2">
                                        Total Amount: ₹{newBooking.serviceFee}
                                    </div>
                                </div>
                            );
                        })()}


                        {/* SERVICE DATE */}
                        <input
                            type="date"
                            className="w-full border rounded-lg px-3 py-2 text-sm text-gray-500"
                            value={newBooking.serviceDate}
                            onChange={(e) =>
                                setNewBooking({ ...newBooking, serviceDate: e.target.value })
                            }
                        />

                        {/* TIME SLOT */}
                        <select
                            className="w-full border rounded-lg px-3 py-2 text-sm text-gray-500"
                            value={newBooking.serviceTimeSlot}
                            onChange={(e) =>
                                setNewBooking({ ...newBooking, serviceTimeSlot: e.target.value })
                            }
                        >
                            <option value="">Select Time Slot</option>
                            {timeSlotsList.map((slot, idx) => (
                                <option key={idx} value={slot}>
                                    {slot}
                                </option>
                            ))}
                        </select>

                        {/* ADDRESS */}
                        <textarea
                            rows={2}
                            placeholder="Address"
                            className="w-full border rounded-lg px-3 py-2 text-sm"
                            value={newBooking.address}
                            onChange={(e) =>
                                setNewBooking({ ...newBooking, address: e.target.value })
                            }
                        />


                        {/* MESSAGE */}
                        <textarea
                            rows={3}
                            placeholder="Message (optional)"
                            className="w-full border rounded-lg px-3 py-2 text-sm"
                            value={newBooking.message}
                            onChange={(e) =>
                                setNewBooking({ ...newBooking, message: e.target.value })
                            }
                        />
                        <select
                            className="w-full border rounded-lg px-3 py-2 text-sm text-gray-500"
                            value={newBooking.paymentMode}
                            onChange={(e) => setNewBooking({ ...newBooking, paymentMode: e.target.value })}
                        >
                            <option value="cash">COD</option>
                            <option value="online">Online (Pending)</option>
                        </select>



                        <div className="flex justify-end gap-3">
                            <button
                                onClick={() => setCreateModal(false)}
                                className="px-4 py-2 border rounded-lg"
                            >
                                Cancel
                            </button>

                            <button
                                onClick={handleCreateBooking}
                                className="px-4 py-2 bg-[#24ADD7] text-white rounded-lg text-sm font-semibold"
                            >
                                Create
                            </button>

                        </div>

                    </div>
                </div>
            )}



            {/* Confirm Complete Modal */}
            {modalType === "confirm_complete" && (
                <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
                    <div className="bg-white rounded-xl w-[400px] p-6 space-y-4">
                        {/* Warning Icon aur Title */}
                        <div className="flex items-center gap-3">
                            <div className="w-10 h-10 bg-amber-100 rounded-full flex items-center justify-center text-amber-600">
                                ⚠️
                            </div>
                            <h3 className="text-lg font-semibold text-[#434646]">
                                Confirm Completion
                            </h3>
                        </div>

                        <p className="text-sm text-gray-600">
                            Are you sure you want to mark this service as **Completed**? This action cannot be undone.
                        </p>

                        <div className="flex justify-end gap-3 pt-2">
                            {/* Cancel Button */}
                            <button
                                onClick={closeModal}
                                className="px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50"
                            >
                                Cancel
                            </button>

                            {/* Confirm Button */}
                            <button
                                onClick={() => {
                                    updateStatus(selectedBooking._id, "complete");
                                    setModalType(null);
                                }}
                                className="px-4 py-2 rounded-lg text-white text-sm font-medium bg-[#24ADD7] hover:bg-[#e05a20]"
                            >
                                Yes, Complete
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Assign Service Modal */}
            {modalType === "assign" && (
                <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
                    <div className="bg-white rounded-xl w-[400px] p-6 space-y-4">
                        <h3 className="text-lg font-semibold text-[#434646]">
                            Assign Service
                        </h3>

                        <select
                            value={assignService}
                            onChange={(e) => setAssignService(e.target.value)}
                            className="w-full border rounded-lg px-3 py-2 text-sm
    focus:outline-none focus:ring-2 focus:ring-[#24ADD7]
    border-gray-300 text-[#434646]"
                        >
                            <option value="">Select Service Agent</option>

                            {serviceAgents.map((agent) => (
                                <option key={agent._id} value={agent._id}>
                                    {agent.name} - {agent?.serviceType?.name || ''} - {agent.phone ? `(${agent.phone})` : ""}
                                </option>
                            ))}
                        </select>

                        {/* NAYA FIELD: Upload Service Agent Verify Image */}


                        {/* Loading State Box */}
                        {serviceAjentImageLoading && (
                            <div className="border border-dashed border-gray-300 rounded-lg p-6 bg-gray-50 flex flex-col justify-center items-center space-y-2">
                                {/* Animated Spinner */}
                                <div className="w-8 h-8 border-4 border-gray-200 border-t-[#24ADD7] rounded-full animate-spin"></div>
                                <p className="text-xs text-gray-500 font-medium">Uploading image...</p>
                            </div>
                        )}

                        {/* Image Preview Box (Sirf tab dikhega jab loading khatam ho chuki ho) */}
                        {!serviceAjentImageLoading && serviceAjentImage && (
                            <div className="relative border border-dashed border-gray-300 rounded-lg p-2 bg-gray-50 flex justify-center items-center">
                                <img
                                    src={serviceAjentImage}
                                    alt="Verification Preview"
                                    className="max-h-[150px] w-auto rounded-md object-contain"
                                />

                                {/* Remove Button */}
                                <button
                                    type="button"
                                    onClick={() => {
                                        setServiceAjentImage("");
                                    }}
                                    className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs hover:bg-red-600 shadow-md"
                                >
                                    ✕
                                </button>
                            </div>
                        )}

                        <div className="flex justify-end gap-3">
                            <button onClick={closeModal} className="px-4 py-2 border rounded-lg">
                                Cancel
                            </button>


                            {/* ✅ Naya Assign Button (Isse replace karein): */}
                            <button
                                disabled={!assignService.trim()}
                                onClick={() => {
                                    if (!assignService.trim()) {
                                        return showErrorToast("Please select a service agent");
                                    }

                                    updateStatus(selectedBooking._id, "assigned", {
                                        service: assignService.trim(),
                                        serviceProviderImage: ""
                                    });

                                    setModalType(null);
                                    setAssignService("");
                                }}
                                className={`px-4 py-2 rounded-lg text-white font-semibold transition-all ${!assignService.trim()
                                    ? "bg-gray-400 cursor-not-allowed"
                                    : "bg-[#24ADD7] hover:bg-blue-600 cursor-pointer"
                                    }`}
                            >
                                Assign
                            </button>


                        </div>
                    </div>
                </div>
            )}

            {/* Reject Service Modal */}
            {modalType === "reject" && (
                <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
                    <div className="bg-white rounded-xl w-[400px] p-6 space-y-4">
                        <h3 className="text-lg font-semibold text-[#434646]">
                            Reject Booking
                        </h3>

                        <textarea
                            rows={3}
                            placeholder="Enter rejection reason"
                            value={rejectReason}
                            onChange={(e) => setRejectReason(e.target.value)}
                            className="w-full border rounded-lg px-3 py-2"
                        />

                        <div className="flex justify-end gap-3">
                            <button onClick={closeModal} className="px-4 py-2 border rounded-lg">
                                Cancel
                            </button>


                            <button
                                disabled={!rejectReason.trim()}
                                onClick={() => {
                                    if (!rejectReason.trim()) {
                                        return showErrorToast("Please enter rejection reason");
                                    }

                                    updateStatus(selectedBooking._id, "rejected", {
                                        service: rejectReason.trim(),
                                    });

                                    setModalType(null);
                                    setRejectReason("");
                                }}
                                className={`px-4 py-2 rounded-lg text-white
        ${!rejectReason.trim()
                                        ? "bg-gray-400 cursor-not-allowed"
                                        : "bg-red-500"
                                    }`}
                            >
                                Reject
                            </button>


                        </div>
                    </div>
                </div>
            )}

            {extraServiceModal && (
                <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-3xl w-full max-w-md p-6 space-y-5 shadow-2xl border border-gray-100">
                        <div className="flex justify-between items-center border-b border-gray-100 pb-4">
                            <h3 className="text-lg font-black text-gray-900 tracking-tight">Select & Add Extra Service</h3>
                            <button
                                onClick={() => setExtraServiceModal(false)}
                                className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center text-gray-500 hover:bg-red-50 hover:text-red-500 transition-all font-bold"
                            >
                                ×
                            </button>
                        </div>

                        {/* 1. Service Dropdown List */}
                        {/* 1. Service Dropdown List */}
                        <div>
                            <label className="text-[11px] font-black text-gray-400 uppercase tracking-wider block mb-2">
                                Choose Service ({currentCategory?.name || "Services"})
                            </label>
                            <select
                                className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm font-semibold text-gray-800 bg-gray-50 focus:bg-white outline-none focus:border-[#24ADD7] transition-all"
                                value={selectedServiceId}
                                onChange={(e) => {
                                    handleSubServiceChange(e.target.value);
                                    if (e.target.value) setCustomServiceName(""); // Dropdown choose karne par manual input clear ho jaye
                                }}
                            >
                                <option value="">-- Choose Sub-Service --</option>
                                {availableSubServices.length > 0 ? (
                                    availableSubServices.map((sub, idx) => (
                                        <option key={idx} value={sub.title}>
                                            {sub.title} - ₹{sub.price}
                                        </option>
                                    ))
                                ) : (
                                    serviceList.map((s) => (
                                        <option key={s._id} value={s.name}>
                                            {s.name}
                                        </option>
                                    ))
                                )}
                            </select>
                        </div>

                        {/* Divider OR */}
                        <div className="flex items-center gap-2 text-gray-400 text-xs font-bold justify-center my-1">
                            <span className="h-[1px] bg-gray-200 flex-1"></span>
                            <span>OR (Manually Enter Extra Service)</span>
                            <span className="h-[1px] bg-gray-200 flex-1"></span>
                        </div>

                        {/* 2. Manual Custom Extra Service Input */}
                        <div>
                            <label className="text-[11px] font-black text-gray-400 uppercase tracking-wider block mb-2">
                                Custom Extra Service Name
                            </label>
                            <input
                                type="text"
                                placeholder="Type service name manually (e.g. Door Repair)"
                                className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm font-semibold text-gray-800 bg-gray-50 focus:bg-white outline-none focus:border-[#24ADD7] transition-all"
                                value={customServiceName}
                                onChange={(e) => {
                                    setCustomServiceName(e.target.value);
                                    if (e.target.value) setSelectedServiceId(""); // Custom type karne par dropdown select clear ho jaye
                                }}
                            />
                        </div>



                        {/* 2. Price Input */}
                        <div>
                            <label className="text-[11px] font-black text-gray-400 uppercase tracking-wider block mb-2">Service Fee / Price (₹)</label>
                            <input
                                type="number"
                                placeholder="Enter Price (e.g. 350)"
                                className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm font-semibold text-gray-800 bg-gray-50 focus:bg-white outline-none focus:border-[#24ADD7] transition-all"
                                value={extraPrice}
                                onChange={(e) => setExtraPrice(e.target.value)}
                            />
                        </div>

                        {/* 3. Action Buttons */}
                        <div className="flex justify-end gap-3 pt-3 border-t border-gray-100">
                            <button
                                onClick={() => setExtraServiceModal(false)}
                                className="px-5 py-2.5 border border-gray-200 rounded-xl text-xs font-bold text-gray-600 hover:bg-gray-50 transition-all"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleSaveExtraService}
                                className="px-6 py-2.5 bg-[#24ADD7] text-white rounded-xl text-xs font-black hover:bg-[#198cae] transition-all shadow-lg shadow-cyan-100"
                            >
                                + Add Service
                            </button>
                        </div>
                    </div>
                </div>
            )}



        {excelModalOpen && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm px-4">
                <div className="bg-white rounded-2xl w-full max-w-md overflow-hidden shadow-2xl p-6">
                    <div className="flex justify-between items-center mb-6">
                        <h3 className="text-xl font-extrabold text-slate-800">Download Excel</h3>
                        <button
                            onClick={() => setExcelModalOpen(false)}
                            className="text-gray-400 hover:text-red-500 transition-colors"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
                        </button>
                    </div>
                    <div className="space-y-4">
                        <div>
                            <label className="block text-sm font-semibold text-slate-700 mb-1">Start Date</label>
                            <input
                                type="date"
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}
                                className="w-full px-4 py-3 rounded-xl border border-gray-200 text-sm text-[#434646] focus:border-[#24ADD7] outline-none"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-semibold text-slate-700 mb-1">End Date</label>
                            <input
                                type="date"
                                value={endDate}
                                onChange={(e) => setEndDate(e.target.value)}
                                className="w-full px-4 py-3 rounded-xl border border-gray-200 text-sm text-[#434646] focus:border-[#24ADD7] outline-none"
                            />
                        </div>
                    </div>
                    <div className="flex justify-end gap-3 mt-8">
                        <button
                            onClick={() => setExcelModalOpen(false)}
                            className="px-5 py-2.5 border border-gray-200 rounded-xl text-sm font-bold text-gray-600 hover:bg-gray-50 transition-all"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={handleExcelDownload}
                            className="px-6 py-2.5 bg-[#24ADD7] text-white rounded-xl text-sm font-black hover:bg-[#198cae] transition-all shadow-lg shadow-cyan-100"
                        >
                            Download
                        </button>
                    </div>
                </div>
            </div>
        )}

        </div>
    );
}
